class Geral {

    produtosMOCK = [
        {
            "idProduto": "14",
            "nome": "Brasil Seikyo Impresso",
            "descricao": "JORNAL IMPRESSO",
            "foto": "",
            "fatorEstatistico": 2,
            "idTipoProduto": 1,
            "ativo": true,
            "sigla": "BS",
            "periodicidade": "semanal",
            "idioma": "português",
            "idPrecoUnitario": 282,
            "valorUnitario": 10.00,
            "valor": "20.00",
        },
        {
            "idProduto": "16",
            "nome": "Terceira Civilização Impressa",
            "descricao": "REVISTA IMPRESSA",
            "foto": "tcativo.png",
            "fatorEstatistico": 1,
            "idTipoProduto": 2,
            "ativo": false,
            "sigla": "TC",
            "periodicidade": "mensal",
            "idioma": "português",
            "idPrecoUnitario": 286,
            "valorUnitario": 25.00,
            "valor": "25.00",
        },
        {
            "idProduto": "13",
            "nome": "Brasil Seikyo Português Digital",
            "descricao": "PRODUTO DIGITAL",
            "foto": "bs-digital.png",
            "fatorEstatistico": 1,
            "idTipoProduto": 3,
            "ativo": true,
            "sigla": "BSD",
            "periodicidade": "mensal",
            "idioma": "português",
            "idPrecoUnitario": 290,
            "valorUnitario": 14,
            "valor": "14",
            "tipoConteudo": "Digital"


        },
        {
            "idProduto": "9",
            "nome": "Terceira Civilização Digital",
            "descricao": "REVISTA DIGITAL",
            "foto": "tcativoonline.png",
            "fatorEstatistico": 1,
            "idTipoProduto": 3,
            "ativo": true,
            "sigla": "TCD",
            "periodicidade": "mensal",
            "idioma": "português",
            "idPrecoUnitario": 294,
            "valorUnitario": 19,
            "valor": "19",
            "tipoConteudo": "Digital"

        },
        {
            "idProduto": "8",
            "nome": "Revista Dez Digital",
            "descricao": "REVISTA DIGITAL",
            "foto": "rdezativo.png",
            "fatorEstatistico": 1,
            "idTipoProduto": 3,
            "ativo": true,
            "sigla": "RDD",
            "periodicidade": "mensal",
            "idioma": "português",
            "idPrecoUnitario": 298,
            "valorUnitario": 10,
            "valor": "10",
            "tipoConteudo": "Digital"

        },
        {
            "idProduto": "12",
            "nome": "Digital completo Individual",
            "descricao": "PRODUTO DIGITAL",
            "foto": "digitalcomplentoonline.png",
            "fatorEstatistico": 1,
            "idTipoProduto": 3,
            "ativo": true,
            "sigla": "DIC",
            "periodicidade": "mensal",
            "idioma": "português",
            "idPrecoUnitario": 302,
            "valorUnitario": 29.90,
            "tipoConteudo": "Digital"

        },
        {
            "idProduto": "10",
            "nome": "Digital completo familiar Duo",
            "descricao": "PRODUTO DIGITAL",
            "foto": "duoonline.png",
            "fatorEstatistico": 1,
            "idTipoProduto": 3,
            "ativo": true,
            "sigla": "DUO",
            "periodicidade": "mensal",
            "idioma": "português",
            "idPrecoUnitario": 306,
            "valorUnitario": 39.90,
            "valor": "39.90",
            "tipoConteudo": "Digital"
        },
        {
            "idProduto": "11",
            "nome": "Digital completo familiar Premium",
            "descricao": "PRODUTO DIGITAL",
            "foto": "premiumonline.png",
            "fatorEstatistico": 1,
            "idTipoProduto": 3,
            "ativo": true,
            "sigla": "PRE",
            "periodicidade": "mensal",
            "idioma": "português",
            "idPrecoUnitario": 310,
            "valorUnitario": 49.90,
            "tipoConteudo": "Digital"

        },
        {
            "idProduto": "15",
            "nome": "Brasil Seikyo Japonês",
            "descricao": "JORNAL IMPRESSO",
            "foto": "bjativo.png",
            "fatorEstatistico": 4,
            "idTipoProduto": 1,
            "ativo": false,
            "sigla": "BJ",
            "periodicidade": "semanal",
            "idioma": "japonês",
            "idPrecoUnitario": 282,
            "valorUnitario": 10.00,
            "valor": "20.00",
            "tipoConteudo": "Digital"
        }
    ]

    periodosMOCK = {
        "BS": [
            {
                "idPeriodo": 4,
                "idOrdem": 2,
                "periodo": "Anual",
                "multiplicador": 12,
                "desconto": 0,
                "valor": "18.00",
                "valorTotal": "216.00",
                "ativo": false
            },
            {
                "idPeriodo": 3,
                "idOrdem": 2,
                "periodo": "Semestral",
                "multiplicador": 6,
                "desconto": 0,
                "valor": "19.00",
                "valorTotal": "114.00",
                "ativo": false
            },
            {
                "idPeriodo": 2,
                "idOrdem": 2,
                "periodo": "Trimestral",
                "multiplicador": 3,
                "desconto": 0,
                "valor": "19.50",
                "valorTotal": "58.50",
                "ativo": false
            },
            {
                "idPeriodo": 1,
                "idOrdem": 3,
                "periodo": "Mensal",
                "multiplicador": 1,
                "desconto": 0,
                "valor": "20.00",
                "valorTotal": "20.00",
                "ativo": false
            }
        ],
        "BJ": [
            {
                "idPeriodo": 4,
                "idOrdem": 2,
                "periodo": "Anual",
                "multiplicador": 12,
                "desconto": 0,
                "valor": "18.00",
                "valorTotal": "216.00",
                "ativo": false
            },
            {
                "idPeriodo": 3,
                "idOrdem": 2,
                "periodo": "Semestral",
                "multiplicador": 6,
                "desconto": 0,
                "valor": "19.00",
                "valorTotal": "114.00",
                "ativo": false
            },
            {
                "idPeriodo": 2,
                "idOrdem": 2,
                "periodo": "Trimestral",
                "multiplicador": 3,
                "desconto": 0,
                "valor": "19.50",
                "valorTotal": "58.50",
                "ativo": false
            },
            {
                "idPeriodo": 1,
                "idOrdem": 3,
                "periodo": "Mensal",
                "multiplicador": 1,
                "desconto": 0,
                "valor": "20.00",
                "valorTotal": "20.00",
                "ativo": false
            }
        ],
        "TC": [
            {
                "idPeriodo": 4,
                "idOrdem": 2,
                "periodo": "Anual",
                "multiplicador": 12,
                "desconto": 0,
                "valor": "22.50",
                "valorTotal": "270.00",
                "ativo": false
            },
            {
                "idPeriodo": 3,
                "idOrdem": 2,
                "periodo": "Semestral",
                "multiplicador": 6,
                "desconto": 0,
                "valor": "23.75",
                "valorTotal": "142.50",
                "ativo": false
            },
            {
                "idPeriodo": 2,
                "idOrdem": 2,
                "periodo": "Trimestral",
                "multiplicador": 3,
                "desconto": 0,
                "valor": "24.40",
                "valorTotal": "73.20",
                "ativo": false
            },
            {
                "idPeriodo": 1,
                "idOrdem": 3,
                "periodo": "Mensal",
                "multiplicador": 1,
                "desconto": 0,
                "valor": "25.00",
                "valorTotal": "25.00",
                "ativo": false
            }
        ],
        "BSD": [
            {
                "idPeriodo": 4,
                "idOrdem": 2,
                "periodo": "Anual",
                "multiplicador": 12,
                "desconto": 0,
                "valor": "11.20",
                "valorTotal": "134.40",
                "ativo": true
            },
            {
                "idPeriodo": 3,
                "idOrdem": 2,
                "periodo": "Semestral",
                "multiplicador": 6,
                "desconto": 0,
                "valor": "12.60",
                "valorTotal": "75.60",
                "ativo": true
            },
            {
                "idPeriodo": 2,
                "idOrdem": 2,
                "periodo": "Trimestral",
                "multiplicador": 3,
                "desconto": 0,
                "valor": "13.30",
                "valorTotal": "39.90",
                "ativo": true
            },
            {
                "idPeriodo": 1,
                "idOrdem": 3,
                "periodo": "Mensal",
                "multiplicador": 1,
                "desconto": 0,
                "valor": "14.00",
                "valorTotal": "14.00",
                "ativo": true
            }
        ],
        "TCD": [
            {
                "idPeriodo": 4,
                "idOrdem": 2,
                "periodo": "Anual",
                "multiplicador": 12,
                "desconto": 0,
                "valor": "15.20",
                "valorTotal": "182.40",
                "ativo": true
            },
            {
                "idPeriodo": 3,
                "idOrdem": 2,
                "periodo": "Semestral",
                "multiplicador": 6,
                "desconto": 0,
                "valor": "17.10",
                "valorTotal": "102.60",
                "ativo": true
            },
            {
                "idPeriodo": 2,
                "idOrdem": 2,
                "periodo": "Trimestral",
                "multiplicador": 3,
                "desconto": 0,
                "valor": "18.00",
                "valorTotal": "54.00",
                "ativo": true
            },
            {
                "idPeriodo": 1,
                "idOrdem": 3,
                "periodo": "Mensal",
                "multiplicador": 1,
                "desconto": 0,
                "valor": "19.00",
                "valorTotal": "19.00",
                "ativo": true
            }
        ]
        ,
        "RDD": [
            {
                "idPeriodo": 4,
                "idOrdem": 2,
                "periodo": "Anual",
                "multiplicador": 12,
                "desconto": 0,
                "valor": "8.00",
                "valorTotal": "96.00",
                "ativo": true
            },
            {
                "idPeriodo": 3,
                "idOrdem": 2,
                "periodo": "Semestral",
                "multiplicador": 6,
                "desconto": 0,
                "valor": "9.00",
                "valorTotal": "54.00",
                "ativo": true
            },
            {
                "idPeriodo": 2,
                "idOrdem": 2,
                "periodo": "Trimestral",
                "multiplicador": 3,
                "desconto": 0,
                "valor": "9.50",
                "valorTotal": "28.50",
                "ativo": true
            },
            {
                "idPeriodo": 1,
                "idOrdem": 3,
                "periodo": "Mensal",
                "multiplicador": 1,
                "desconto": 0,
                "valor": "10.00",
                "valorTotal": "10.00",
                "ativo": true
            }
        ],
        "DUO": [
            {
                "idPeriodo": 4,
                "idOrdem": 2,
                "periodo": "Anual",
                "multiplicador": 12,
                "desconto": 0,
                "valor": "31.90",
                "valorTotal": "382.80",
                "ativo": true
            },
            {
                "idPeriodo": 3,
                "idOrdem": 2,
                "periodo": "Semestral",
                "multiplicador": 6,
                "desconto": 0,
                "valor": "35.90",
                "valorTotal": "215.40",
                "ativo": true
            },
            {
                "idPeriodo": 2,
                "idOrdem": 2,
                "periodo": "Trimestral",
                "multiplicador": 3,
                "desconto": 0,
                "valor": "37.90",
                "valorTotal": "113.70",
                "ativo": true
            },
            {
                "idPeriodo": 1,
                "idOrdem": 3,
                "periodo": "Mensal",
                "multiplicador": 1,
                "desconto": 0,
                "valor": "39.90",
                "valorTotal": "39.90",
                "ativo": true
            }
        ],

        "PRE": [
            {
                "idPeriodo": 4,
                "idOrdem": 2,
                "periodo": "Anual",
                "multiplicador": 12,
                "desconto": 0,
                "valor": "39.90",
                "valorTotal": "478.80",
                "ativo": true
            },
            {
                "idPeriodo": 3,
                "idOrdem": 2,
                "periodo": "Semestral",
                "multiplicador": 6,
                "desconto": 0,
                "valor": "44.90",
                "valorTotal": "269.40",
                "ativo": true
            },
            {
                "idPeriodo": 2,
                "idOrdem": 2,
                "periodo": "Trimestral",
                "multiplicador": 3,
                "desconto": 0,
                "valor": "47.40",
                "valorTotal": "142.20",
                "ativo": true
            },
            {
                "idPeriodo": 1,
                "idOrdem": 3,
                "periodo": "Mensal",
                "multiplicador": 1,
                "desconto": 0,
                "valor": "49.90",
                "valorTotal": "49.90",
                "ativo": true
            }
        ],
        "DIC": [
            {
                "idPeriodo": 4,
                "idOrdem": 2,
                "periodo": "Anual",
                "multiplicador": 12,
                "desconto": 0,
                "valor": "23.90",
                "valorTotal": "286.80",
                "ativo": true
            },
            {
                "idPeriodo": 3,
                "idOrdem": 2,
                "periodo": "Semestral",
                "multiplicador": 6,
                "desconto": 0,
                "valor": "26.90",
                "valorTotal": "161.40",
                "ativo": true
            },
            {
                "idPeriodo": 2,
                "idOrdem": 2,
                "periodo": "Trimestral",
                "multiplicador": 3,
                "desconto": 0,
                "valor": "28.40",
                "valorTotal": "85.20",
                "ativo": true
            },
            {
                "idPeriodo": 1,
                "idOrdem": 3,
                "periodo": "Mensal",
                "multiplicador": 1,
                "desconto": 0,
                "valor": "29.90",
                "valorTotal": "29.90",
                "ativo": true
            }
        ]

    }

    static validarNumero(valor) {
        return Number.isNaN(valor) ? 0 : valor
    }

    static downloadPDF(pdf, nomeArquivo) {
        const linkSource = `data:application/pdf;base64,${pdf}`;
        const downloadLink = document.createElement("a");
        const fileName = `${nomeArquivo}.pdf`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    static downloadFile(file, nomeArquivo, type) {
        const linkSource = `data:text/${type};base64,${file}`;
        const downloadLink = document.createElement("a");
        const fileName = `${nomeArquivo}.${type}`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    }

    static badgeProductType(type) {
        let _badge = 'info';
        switch (type.toUpperCase()) {
            case "BS":
                _badge = 'primary';
                break;
            case "BSD":
                _badge = 'primary';
                break;
            case "BJ":
                _badge = 'success';
                break;
            case "TC":
                _badge = 'danger';
                break;
            case "TCD":
                _badge = 'danger';
                break;
            case "RDD":
                _badge = 'warning';
                break;
            case "DA":
                _badge = 'secondary';
                break;
            case "GPV":
                _badge = 'info';
                break;
            default:
                _badge = 'info';
                break;
        }
        return _badge;
    }

    static paymentBadgeType(status) {
        switch (status) {
            case "pago":
                return "success";
            case "vencido":
                return "secondary";
            case "negado":
                return "danger";
            case "Baixa Manual":
                return "primary";
            default: // case 1, 3
                return "warning";
        }
    }

    static tipoBadgeStatusPedido(status) {
        let _color;
        switch (status) {
            case 6:
                _color = 'danger';
                break;
            case 7:
                _color = 'info';
                break;
            default:
                _color = 'primary';
                break;
        }

        return _color;
    }

    static tipoBadgePrioridade(status) {
        switch (status) {
            case 1:
                return "secondary";
            case 2:
                return "warning";
            default: // 3
                return "danger";
        }
    }



    static tipoBadgeAtendimento(status) {
        switch (status) {
            case 2:
                return "warning";
            case 3:
                return "info";
            case 4:
                return "success";
            default: //
                return "primary";
        }
    }

    static obtemTipoBadge(tipo) {

        let _tipoBadge;
        let _textColorInside = 'white';
        let _textColorOutside;

        switch (tipo.toLowerCase()) {
            case "bd":
                _tipoBadge = 'dark';
                _textColorOutside = _tipoBadge;
                break;
            case "bm":
                _tipoBadge = 'verdeBM';
                _textColorOutside = _tipoBadge;
                break;
            case "tc":
                _tipoBadge = 'danger';
                _textColorOutside = _tipoBadge;
                break;
            case "rd":
                _tipoBadge = 'warning';
                _textColorOutside = 'dark';
                _textColorInside = 'dark';
                break;
            case "rdd":
                _tipoBadge = 'warning';
                _textColorOutside = 'dark';
                _textColorInside = 'dark';
                break;
            case "bj":
                _tipoBadge = 'success';
                _textColorOutside = _tipoBadge;
                break;
            case "da":
                _tipoBadge = 'secondary';
                _textColorOutside = _tipoBadge;
                break;
            case "s": //solicitante
                _tipoBadge = 'lightblue';
                _textColorOutside = _tipoBadge;
                break;
            case "b": //beneficiário
                _tipoBadge = 'lightgreen';
                _textColorOutside = _tipoBadge;
                break;
            default:
                _tipoBadge = 'primary';
                _textColorOutside = _tipoBadge;
                break;
        }

        return {
            textColorOutside: `${_textColorOutside}`,
            textColorInside: `${_textColorInside}`,
            badgeColor: `${_tipoBadge}`,
            btnOutColor: `${_tipoBadge}`,
        }
    }

    static tipoBadgeStatusArtigo(status) {
        switch (status) {
            case "Disponível":
                return 'primary'
            case "Agendado":
                return 'info'
            case "Pendente":
                return 'orange text-white'
            default:
                return 'secondary badge-opacity'
        }
    }

    static formataNumero(v) {
        return v !== undefined ? v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") : 0;
    }

    static obtemCoresSelect(index) {

        let _tipoBadge;
        let _textColorInside;

        switch (index) {
            case 0:
                _tipoBadge = 'pink';
                _textColorInside = 'white';
                break;
            case 1:
                _tipoBadge = 'purple';
                _textColorInside = 'white';
                break;
            case 2:
                _tipoBadge = 'orange';
                _textColorInside = 'white';
                break;
            case 3:
                _tipoBadge = 'lightblue';
                _textColorInside = 'dark';
                break;
            case 4:
                _tipoBadge = 'lightgreen';
                _textColorInside = 'dark';
                break;

            default:
                _tipoBadge = "secondary"
                _textColorInside = "dark"
        }

        return {
            textColorInside: `${_textColorInside}`,
            badgeColor: `${_tipoBadge}`,
        }
    }

}

export default Geral;